// Vendor Libs
import React, {useEffect} from 'react';
import PropTypes from 'prop-types';

// Dish Tech React
import {InputTextField} from '@dishtech-react/core';

// Material UI
import Grow from '@material-ui/core/Grow';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import SearchIcon from '@material-ui/icons/Search';
import {makeStyles} from '@material-ui/core/styles';

const CARRIAGE_RETURN = 13;
const ANIMATION_DURATION = 300;

const useStyles = makeStyles(theme => ({
  main: {
    display: 'flex',
    flex: '1 0 auto',
  },
  clearIcon: {
    '&:hover': {
      color: theme.palette.error.main,
    },
  },
  searchIcon: {
    height: '80px',
    marginRight: -20,
  },
}));

const CustomSearch = ({searchText, onHide, onSearch}) => {
  const classes = useStyles();

  const onKeyDown = event => {
    if (event.keyCode === CARRIAGE_RETURN) {
      onSearch();
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', onKeyDown, false);

    return () => document.removeEventListener('keydown', onKeyDown, false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grow in={true} timeout={ANIMATION_DURATION}>
      <div className={classes.main}>
        <InputTextField fullWidth={true} inputRef={searchText} type="text" variant="standard" />

        <IconButton
          className={classes.searchIcon}
          onClick={() => {
            onSearch();
          }}
        >
          <SearchIcon />
        </IconButton>

        <IconButton className={classes.clearIcon} onClick={onHide}>
          <ClearIcon />
        </IconButton>
      </div>
    </Grow>
  );
};

CustomSearch.propTypes = {
  onHide: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  searchText: PropTypes.object,
};

export default CustomSearch;
